import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import { useEffect, useRef } from 'react';
import Navbar from './components/navbar/Navbar';
import FAQsPage from './pages/FAQsPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import ProjectPage from './pages/ProjectPage';
import CareersPage from './pages/CareersPage';
import GalleryPage from './pages/GalleryPage';

function App() {

  const isBlurredRef = useRef(false);

  useEffect(() => {
    const disableContextMenu = (e) => e.preventDefault();
    const disableDrag = (e) => e.preventDefault();

    document.addEventListener("contextmenu", disableContextMenu);
    document.addEventListener("dragstart", disableDrag);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("dragstart", disableDrag);
    };
  }, []);

  // FIXED: Keep blur active for longer duration
  useEffect(() => {
    const blockKeys = (e) => {
      // Check for PrintScreen or screenshot shortcuts
      if (
        e.key === "PrintScreen" ||
        (e.ctrlKey && e.shiftKey && (e.key === 'S' || e.key === 's')) || // Chrome screenshot
        (e.metaKey && e.shiftKey && e.key === '3') || // Mac screenshot
        (e.metaKey && e.shiftKey && e.key === '4') || // Mac screenshot
        (e.metaKey && e.shiftKey && e.key === '5')    // Mac screenshot (full screen)
      ) {
        e.preventDefault();
        
        // Apply blur immediately with no transition
        document.body.style.transition = 'none';
        document.body.style.filter = 'blur(20px)';
        isBlurredRef.current = true;
        
        // Keep blur active for 2 seconds (enough time for screenshot tool to capture)
        setTimeout(() => {
          document.body.style.filter = 'none';
          isBlurredRef.current = false;
        }, 2000);
        
        return false;
      }

      // Also block Ctrl+S (save page)
      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        // alert("Saving is disabled on this page.");
      }
    };

    // Use both keydown and keyup
    window.addEventListener("keydown", blockKeys);
    window.addEventListener("keyup", blockKeys);
    
    return () => {
      window.removeEventListener("keydown", blockKeys);
      window.removeEventListener("keyup", blockKeys);
    };
  }, []);

  // Blur when window loses focus
  useEffect(() => {
    const handleBlur = () => {
      // Check if the focus is moving to an iframe (like the YouTube video)
      // We use a small delay because document.activeElement doesn't update instantly
      setTimeout(() => {
        if (document.activeElement && document.activeElement.tagName === 'IFRAME') {
          // It's an iframe, don't blur
          return;
        }

        if (!isBlurredRef.current) {
          document.body.style.transition = 'none';
          document.body.style.filter = 'blur(20px)';
        }
      }, 100);
    };
    
    const handleFocus = () => {
      if (!isBlurredRef.current) {
        setTimeout(() => {
          document.body.style.filter = 'none';
        }, 100);
      }
    };

    window.addEventListener('blur', handleBlur);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  // Log visibility changes
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (!isBlurredRef.current) {
          document.body.style.transition = 'none';
          document.body.style.filter = 'blur(20px)';
        }
      } else {
        if (!isBlurredRef.current) {
          setTimeout(() => {
            document.body.style.filter = 'none';
          }, 100);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navbar />} >
          <Route index element={<HomePage />} />
          <Route path='/faqs' element={<FAQsPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/projects' element={<ProjectPage />} />
          <Route path='/careers' element={<CareersPage />} />
          <Route path='/gallery' element={<GalleryPage />} />
        </Route>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;